// import Vue from 'vue'
// import ajax from './ajax'
// import wx from 'wb-wx-js-sdk'
import { GetJsApiConfig } from '@/api/wx'
import { store } from '../store'
import { Notify } from 'vant'

let wxShare = async function(params) {
  if (!params) {
    params = {}
  }
  try {
    let wxConfigInfo = store.state.wxConfigInfo
    if (!wxConfigInfo.signature) {
      let sigData = await GetJsApiConfig()
      wxConfigInfo = JSON.parse(sigData)
      store.commit('SET_WX_CONFIG_INFO', wxConfigInfo)
    }
    window.wx.config({
      debug: false,
      appId: wxConfigInfo.appId,
      timestamp: wxConfigInfo.timestamp,
      nonceStr: wxConfigInfo.nonceStr,
      signature: wxConfigInfo.signature,
      jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']
    })
    window.wx.ready(function() {
      let title = params.title
      let link = params.link
      let desc = params.desc
      let imgUrl = params.imgUrl
      // 分享到朋友圈
      window.wx.updateTimelineShareData({
        title: title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function(res) {
          // console.log("timeline success");
          // 用户确认分享后执行的回调函数
          console.log('设置成功, updateTimelineShareData', res)
        },
        trigger: function(res) {
          console.log('trigger updateTimelineShareData ', res)
        }
      })
      // 分享给朋友
      window.wx.updateAppMessageShareData({
        title: title, // 分享标题
        desc: desc,
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function(res) {
          // 用户确认分享后执行的回调函数
          console.log('设置成功 updateAppMessageShareData', res)
        },
        trigger: function(res) {
          console.log('trigger updateAppMessageShareData ', res)
        }
      })
    })
  } catch (e) {
    Notify({ type: 'danger', message: e.message })
  }
}
export const WxShare = wxShare
export const WxConfig = async function() {
  try {
    let wxConfigInfo = store.state.wxConfigInfo
    if (!wxConfigInfo.signature) {
      let sigData = await GetJsApiConfig()
      wxConfigInfo = JSON.parse(sigData)
      store.commit('SET_WX_CONFIG_INFO', wxConfigInfo)
    }
    window.wx.config({
      debug: false,
      appId: wxConfigInfo.appId,
      timestamp: wxConfigInfo.timestamp,
      nonceStr: wxConfigInfo.nonceStr,
      signature: wxConfigInfo.signature,
      jsApiList: [
        'updateTimelineShareData',
        'updateAppMessageShareData',
        'chooseWXPay'
      ]
    })
  } catch (e) {
    Notify({ type: 'danger', message: e.message })
  }
}
